// removed by extract-text-webpack-plugin
module.exports = {"base":"Slider_base--Y9z36","navigation":"Slider_navigation--q5Z2-","content":"Slider_content--_-3AW","button":"Slider_button--3g4e5"};


//////////////////
// WEBPACK FOOTER
// ./containers/MigrationScreen/components/Slider/Slider.scss
// module id = 2181
// module chunks = 11